export default __webpack_public_path__ + "static/media/misc-closetB-2048w.de74860a.png";